import { render, staticRenderFns } from "./AddNewRecipientPopup.vue?vue&type=template&id=25993380"
import script from "./AddNewRecipientPopup.vue?vue&type=script&lang=ts"
export * from "./AddNewRecipientPopup.vue?vue&type=script&lang=ts"
import style0 from "./AddNewRecipientPopup.vue?vue&type=style&index=0&id=25993380&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports